import React from 'react';

const HeaderTopBar = () => {

  return (
    <div className="announcement-bar">
      <div className="announcement-content">
        <span className="announcement-text">FAST, FRIENDLY DELIVERY IN DTLA</span>
      </div>
    </div>
  )
}

export default HeaderTopBar;



// WEBPACK FOOTER //
// ./src/components/commons/header/HeaderTop.js